import { ReactNode } from 'react';

import { SnackbarProvider } from 'notistack';

interface NotificationProviderProps {
  children: ReactNode;
}

/**
 * NotificationProvider wraps the application with Notistack's SnackbarProvider
 * configured with accessibility and UX best practices:
 *
 * - Success/info snackbars auto-hide in 3s with no close button (accessibility minimum)
 * - Error/warning snackbars last 7s with close button (longer readability)
 * - Snackbars with actions last 6s or can be set to persist
 * - Bottom-center placement for consistency
 * - Maximum of 3 visible snackbars at once
 * - Prevents duplicate notifications
 * - Close buttons are keyboard accessible (Tab + Enter) when shown
 * - ARIA roles configured via useNotification hook
 * - Per-notification durations are set in useNotification hook
 */
export const NotificationProvider = ({
  children,
}: NotificationProviderProps) => {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      preventDuplicate
      disableWindowBlurListener={false}
    >
      {children}
    </SnackbarProvider>
  );
};
